import ClassicGrid from "./ClassicGrid";

export default ClassicGrid;
